import React from 'react'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import WorksContent from './WorksContent'
import { IPropsWorks } from '../interfaces'
import { api } from '@/api'

const Works = ({ id }: IPropsWorks): React.ReactElement => {
  return (
    <FetcherList
      initFilter={{ page: 1, page_size: 8, id, q: '' }}
      isScrollTop={false}
      isHistoryPush={false}
      api={api.getContestWorks}
    >
      {(props: IFetcherListResults<any[]>) => {
        return <WorksContent {...props} />
      }}
    </FetcherList>
  )
}

export default Works
